export type StatusVariant = "ok" | "issue" | "neutral";

// Maps a buyer verdict (fulfilled / not fulfilled / not yet reviewed) to a status variant.
export const verdictToStatusVariant = (verdict: boolean | null): StatusVariant => {
  if (verdict === true) return "ok";
  if (verdict === false) return "issue";
  return "neutral";
};
